var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcbCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H30V14C30 17.3137 27.3137 20 24 20H0V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6325",
    d: "M27.8303 15.9167C27.8303 18.1198 26.0365 19.9136 23.8334 19.9136H2.08643V4.08334C2.08643 1.88032 3.88032 0.0864258 6.08334 0.0864258H27.8303V15.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6338",
    d: "M20.7492 11.8568H22.4015C22.4487 11.8568 22.5588 11.8411 22.606 11.8411C22.9208 11.7782 23.1883 11.4949 23.1883 11.1015C23.1883 10.7239 22.9208 10.4406 22.606 10.3619C22.5588 10.3462 22.4644 10.3462 22.4015 10.3462H20.7492V11.8568Z",
    fill: "url(#paint0_linear_17764_32426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6349",
    d: "M22.2126 1.42383C20.639 1.42383 19.3487 2.69844 19.3487 4.28776V7.26184H23.3928C23.4872 7.26184 23.5974 7.26184 23.6761 7.27758C24.5887 7.32479 25.2654 7.79686 25.2654 8.61513C25.2654 9.2603 24.809 9.81106 23.9593 9.92121V9.95268C24.8877 10.0156 25.5958 10.5349 25.5958 11.3374C25.5958 12.2029 24.809 12.7694 23.7705 12.7694H19.3329V18.5917H23.5344C25.108 18.5917 26.3984 17.3171 26.3984 15.7278V1.42383H22.2126Z",
    fill: "url(#paint1_linear_17764_32426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6360",
    d: "M22.9837 8.8042C22.9837 8.42653 22.7162 8.17476 22.4015 8.12755C22.37 8.12755 22.2913 8.11182 22.2441 8.11182H20.7492V9.49657H22.2441C22.2913 9.49657 22.3857 9.49657 22.4015 9.48084C22.7162 9.43363 22.9837 9.18186 22.9837 8.8042Z",
    fill: "url(#paint2_linear_17764_32426)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6371",
    d: "M6.38235 1.42383C4.80876 1.42383 3.51842 2.69844 3.51842 4.28776V11.3532C4.32095 11.7466 5.15495 11.9983 5.98896 11.9983C6.98032 11.9983 7.51534 11.4004 7.51534 10.5821V7.24611H9.97014V10.5664C9.97014 11.8567 9.16761 12.911 6.4453 12.911C4.79303 12.911 3.50269 12.5491 3.50269 12.5491V18.5759H7.70417C9.27776 18.5759 10.5681 17.3013 10.5681 15.712V1.42383H6.38235Z",
    fill: "url(#paint3_linear_17764_32426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6384",
    d: "M14.2975 1.42383C12.7239 1.42383 11.4335 2.69844 11.4335 4.28776V8.0329C12.1574 7.4192 13.4163 7.02581 15.4462 7.12022C16.532 7.16743 17.6964 7.46641 17.6964 7.46641V8.67807C17.1142 8.37909 16.4218 8.11158 15.5249 8.04864C13.9827 7.93849 13.0543 8.69381 13.0543 10.0156C13.0543 11.3532 13.9827 12.1085 15.5249 11.9826C16.4218 11.9197 17.1142 11.6364 17.6964 11.3532V12.5648C17.6964 12.5648 16.5477 12.8638 15.4462 12.911C13.4163 13.0054 12.1574 12.612 11.4335 11.9983V18.6074H15.635C17.2086 18.6074 18.4989 17.3328 18.4989 15.7435V1.42383H14.2975Z",
    fill: "url(#paint4_linear_17764_32426)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17764_32426",
    x1: 19.3461,
    y1: 11.1034,
    x2: 26.4174,
    y2: 11.1034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17764_32426",
    x1: 19.3458,
    y1: 10.0009,
    x2: 26.4177,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17764_32426",
    x1: 19.3459,
    y1: 8.80223,
    x2: 26.4175,
    y2: 8.80223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17764_32426",
    x1: 3.51509,
    y1: 10.0009,
    x2: 10.6959,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17764_32426",
    x1: 11.3928,
    y1: 10.0009,
    x2: 18.367,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbCardIcon);
export default __webpack_public_path__ + "static/media/jcb-card-icon.f839d36e922239d9dc5db6738129aa63.svg";
export { ForwardRef as ReactComponent };